import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './override-colors.css';
import './force-no-yellow.css';
import App from './App';
import { Toaster } from './components/ui/sonner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Toaster position="top-right" richColors />
  </React.StrictMode>
);
